<template>
  <div class="real_task_wrap">
    <student></student>
    <!-- <teacher></teacher> -->
  </div>
</template>
<script>
import student from './studentTask.vue'
// import teacher from './teacherTask.vue'
export default {
  components: { student  },
  data() {
    return {  
      userType: sessionStorage.getItem('userType'), //这里本是localStorage
      active: 'first'
    }
  },
  mounted() {
    // if(this.userType==0||this.userType==1){//这里本是0 1 
    //   this.active = 'thrid'
    // }else{
    //   this.active = 'second'
    // }
  },
  methods: {
    
  },
}
</script>
<style lang="scss">
  .real_task_wrap{
    width: 100%;
    height: 100%;
    background: #F4F4F4;
    padding: 16px;
    box-sizing: border-box;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/realTask/index.vue